import React from 'react';
import color from '../../../../config/colors.json';
import Charts from '../../../../components/Campanhas/Charts';
import EasyFast from '../../../../components/Campanhas/ChooseCampaign';
import { ReactComponent as Hand } from '../../../../img/combinedshape.svg';
import CardWithTitle from '../../../../components/Campanhas/CardWithTitle';

const Painel = () => (
	<>
		<CardWithTitle
			title="Para você anunciar sua loja ou seus veículos no Google, Facebook e Instagram."
			icon={(<Hand fill={color.light} />)}
		>
			<Charts />
		</CardWithTitle>
		<EasyFast />
	</>
    );
export default Painel;
